import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

const base_api_url = "koranreport";
export default {
    omsetkotachart(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['kota_id', 'kota_name', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koranreport/omsetkotachart${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    omsetkotalist(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['kota_id', 'kota_name', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koranreport/omsetkotalist${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    omsetkotalistexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['kota_id', 'kota_id', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/koranreport/omsetkotalistexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `sales_${obj.tgl2}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    omsetsalesaechart(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['salesae_id', 'salesae_name', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koranreport/omsetsalesaechart${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    omsetsalesaelist(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['salesae_id', 'salesae_name', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koranreport/omsetsalesaelist${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    omsetsalesaelistexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['salesae_id', 'salesae_id', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/koranreport/omsetsalesaelistexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `sales_${obj.tgl2}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    omsetareachart(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['area_id', 'area_name', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koranreport/omsetareachart${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    omsetarealist(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['area_id', 'area_name', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koranreport/omsetarealist${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    omsetarealistexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['area_id', 'area_id', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/koranreport/omsetarealistexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `sales_${obj.tgl2}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    
    omsetedisichart(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['week_id', 'week_name', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koranreport/omsetedisichart${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    omsetedisilist(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['week_id', 'week_name', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koranreport/omsetedisilist${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    omsetedisilistexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['week_id', 'week_name', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/koranreport/omsetedisilistexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `sales_${obj.tgl2}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    // omsetposting(obj) {
    //     return new Promise(async (resolve, reject) => {
    //         try {
    //             const { data } = await axios.post("koranomset", obj);
    //             resolve(data);
    //         } catch (error) {
    //             errorHandler(error, reject)
    //         }
    //     });
    // },
    omset(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'customer_id', 'CustName', 'kiriman_code', 'tgl1', 'tgl2', 'prosesulang'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koranomset/omset${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    omsetexport(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'customer_id', 'CustName', 'kiriman_code', 'tgl1', 'tgl2', 'prosesulang'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koranomset/omsetexportxls${str}`;

                const response = axios({
                    url,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(response);
            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });
    },
    omsetprint(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = [ 'sortDir', 'customer_id', 'CustName', 'kiriman_code', 'tgl1', 'tgl2', 'prosesulang'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koranomset/omsetprint${str}`;
                const { data } = await axios.get(url,obj.sections);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    detailhitungan(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tanggal',  'customer_id', 'CustName', 'periode', 'tgl1', 'tgl2', 'kiriman_code', 'arrKey', 'prosesulang'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koranomsethitung/detailhitungan${str}`
                const { data } = await axios.get(url,obj.sections);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    detailhitunganxls(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'customer_id', 'CustName', 'periode', 'tgl1', 'tgl2', 'kiriman_code', 'arrKey', 'prosesulang'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koranomsethitung/detailhitunganxls${str}`;

                const response = axios({
                    url,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(response);
            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });
    },
     
    trxrekening(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['customer_id', 'CustName', 'custinfo', 'tgl2', 'alltrx'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koranreport/trxrekening${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    trxrekeningexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['customer_id', 'CustName', 'custinfo', 'tgl2', 'alltrx'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/koranreport/trxrekeningexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `rekening-koran-agen_${obj.tgl2}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    trxrekeningprint(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['customer_id', 'CustName', 'custinfo', 'tgl2', 'alltrx'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koranreport/trxrekeningprint${str}`;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    ordercetak(obj) {
        return new Promise(async (resolve, reject) => {
            try {

                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2', 'percetakan_id', 'percetakan_name'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${base_api_url}/ordercetak${str}`
                const { data } = await axios.get(url);
                const { meta, list } = data;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    ordercetakPrint(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl1', 'tgl2',  'percetakan_id', 'percetakan_name'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${base_api_url}/ordercetakprint${str}`
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    ordercetakXls(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl1', 'tgl2',  'percetakan_id', 'percetakan_name'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const response = await axios({
                    url: `/${base_api_url}/ordercetakxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });

                resolve(response);
            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });
    },
    // fakturKirimProses(obj) {
    //     return new Promise(async (resolve, reject) => {
    //         try {
    //             const keys = ['tanggal', 'customer_id', 'koliMinimum', 'koliNormal', 'koliToleransi', 'jurusanId'];
    //             let str = '';
    //             for (const key in obj) {
    //                 if (keys.indexOf(key) >= 0 && obj[key]) {
    //                     str += str ? '&' : '?';
    //                     str += key + '=' + encodeURIComponent(obj[key]);
    //                 }
    //             }
    //             const url = `/${base_api_url}/fakturKirimProses`;
    //             const { data } = await axios.post(url, obj);
    //             resolve(data);
    //         } catch (error) {
    //             errorHandler(error, reject);
    //         }
    //     });
    // },
    // fakturKirimPrint(obj) {
    //     return new Promise(async (resolve, reject) => {
    //         try {
    //             const keys = ['tanggal', 'customer_id', 'koliMinimum', 'koliNormal', 'koliToleransi', 'jurusanId', 'section_no', 'isPrintedForm', 'sectionPrinted'];
    //             let str = '';
    //             for (const key in obj) {
    //                 if (keys.indexOf(key) >= 0 && obj[key]) {
    //                     str += str ? '&' : '?';
    //                     str += key + '=' + encodeURIComponent(obj[key]);
    //                 }
    //             }
    //             const url = `/${base_api_url}/fakturKirimPrint${str}`
    //             const { data } = await axios.get(url);
    //             const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
    //             resolve(link);
    //         } catch (error) {
    //             errorHandler(error, reject);
    //         }
    //     });
    // },
    fakturKirimKoli(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tanggal', 'customer_id', 'koliMinimum', 'koliNormal', 'koliToleransi', 'jurusanId', 'section_no', 'sectionPrinted'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${base_api_url}/fakturkirimkoli${str}`
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    fakturKirimMIPrint(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tanggal', 'customer_id', 'jurusan_id', 'isPrintedForm'];
                let str = '';
                console.log('str',str)
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${base_api_url}/fakturKirimMIPrint${str}`
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    // suratJalanProses(obj) {
    //     return new Promise(async (resolve, reject) => {
    //         try {
    //             const keys = ['tanggal', 'jurusanId'];
    //             let str = '';
    //             for (const key in obj) {
    //                 if (keys.indexOf(key) >= 0 && obj[key]) {
    //                     str += str ? '&' : '?';
    //                     str += key + '=' + encodeURIComponent(obj[key]);
    //                 }
    //             }
    //             const url = `/${base_api_url}/suratJalanProses${str}`
    //             const { data } = await axios.put(url, obj.sections);
    //             resolve(data);
    //         } catch (error) {
    //             errorHandler(error, reject);
    //         }
    //     });
    // },
    // suratJalanPrint(obj) {
    //     return new Promise(async (resolve, reject) => {
    //         try {
    //             const keys = ['tanggal', 'jurusanId'];
    //             let str = '';
    //             for (const key in obj) {
    //                 if (keys.indexOf(key) >= 0 && obj[key]) {
    //                     str += str ? '&' : '?';
    //                     str += key + '=' + encodeURIComponent(obj[key]);
    //                 }
    //             }
    //             const url = `/${base_api_url}/suratJalanPrint${str}`
    //             const { data } = await axios.get(url);
    //             const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
    //             resolve(link);
    //         } catch (error) {
    //             errorHandler(error, reject);
    //         }
    //     });
    // },
    suratJalanKoli(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tanggal', 'jurusanId'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                // str +=  '&sectionns='+  JSON.stringify(obj.sections);
                const url = `/${base_api_url}/suratjalankoli${str}`
                const { data } = await axios.post(url,obj.sections);
                // const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    suratJalanMIPrint(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tanggal', 'jurusan_id','customer_id'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${base_api_url}/suratJalanMIPrint${str}`
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    titipanBermasalah(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/${base_api_url}/titipanbermasalah/${encodeURIComponent(obj.tanggal)}`
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    titipanUpdateAgen(obj) {
        return new Promise(async function (resolve, reject) {
            try {
                const url = `/KoranKiriman/kirimtitipke`
                await axios.put(url, obj);
                resolve(true)
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    koranSetinganSave(obj) {
        return new Promise(async function (resolve, reject) {
            try {
                const url = `/${base_api_url}/setinganKoli`
                 await axios.post(url, obj);
                resolve(true)
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    getKoranSetingan(obj) {
        return new Promise(async function (resolve, reject) {
            try {
                const keys = ['tanggal', 'section_no'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                const url = `/${base_api_url}/setinganKoli/${str}`;
                const { data } = await axios.get(url, obj);
                resolve(data)
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },

    omsetjenischart(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['jenis_id', 'jenis_name', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koranreport/omsetjenischart${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    omsetjenislist(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['jenis_id', 'jenis_name', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koranreport/omsetjenislist${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    omsetjenislistexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['jenis_id', 'jenis_name', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/koranreport/omsetjenislistexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `sales_${obj.tgl2}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    oplahjenischart(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['jenis_id', 'jenis_name', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koranreport/oplahjenischart${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    oplahjenislist(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['jenis_id', 'jenis_name', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koranreport/oplahjenislist${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    oplahjenislistexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['jenis_id', 'jenis_name', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
    
                axios({
                    url: `/koranreport/oplahjenislistexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `oplah_${obj.tgl2}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    
}